import { Card, Col, Row, Tabs, TabsProps, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { TableactivityList } from "./components/activity-list-table";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { Activityservice } from "./services/importfile.service";
import { loadAppConfig } from "../../configs/app-config";

const { Title } = Typography;

interface IActivityall {
  id: number;
  agendaId: string;
  name: string;
  description: string;
  type: string;
  number: number;
  fixLimit: boolean;
  numberChar: string;
  createDate: string;
  updateDate: string;
}
export const MainactivityList: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [statusRefesh, setStatusRefesh] = useState<boolean>(true);
  const [activityAll, setActivityAll] = useState<IActivityall[]>([]);

  useEffect(() => {
    if (statusRefesh) {
      featchData();
    }
  }, [statusRefesh]);

  const featchData = async () => {
    const resultActivityAll = await Activityservice(apiBaseUrl).getlistActivityAll();
    setActivityAll(resultActivityAll);
    setStatusRefesh(false);
  };

  return (
    <>
      <Card>
        <Title level={3}>กิจกรรมทั้งหมด</Title>
      </Card>
      <div className="divContent">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <TableactivityList dataResult={activityAll} />
          </Col>
        </Row>
      </div>
    </>
  );
};
